import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import { toLineHeight } from "chart.js/helpers";

export const CVenueHighlightsSection = ({ id }) => {
  const [venueHighlights, setVenueHighlights] = useState([]);
  const [selectedHighlights, setSelectedHighlights] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `VenueHighlights/GetVenueHighlightsDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedHighlights = response.map((highlight) => ({
          ...highlight,
          image: `${ImageURL}${highlight.imagePath}`,
        }));
        setVenueHighlights(mappedHighlights);
      } else {
        setVenueHighlights([]);

        console.log("No venue highlights found");
      }
    } catch (error) {
      setVenueHighlights([]);
      console.error("Error fetching venue highlights:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (venueHighlights?.length) {
      $(".blog-home .owl-carousel").owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        navText: [
          "<span class='lnr ti-angle-left'></span>",
          "<span class='lnr ti-angle-right'></span>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });
    }
  }, [JSON.stringify(venueHighlights)]);

  const openModal = (highlight) => {
    setSelectedHighlights(highlight);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedHighlights(null);
    setIsModalOpen(false);
  };

  if (!venueHighlights || venueHighlights.length === 0) {
    return null;
  }
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const truncateDescription = (text, maxLength) => {
    const strippedText = stripHtmlTags(text);
    if (strippedText.length > maxLength) {
      return {
        short: `${strippedText.substring(0, maxLength)}...`,
        full: strippedText,
      };
    }
    return {
      short: strippedText,
      full: strippedText,
    };
  };
  return (
    <>
      <section className="blog-home section-padding">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Venue Highlights</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="owl-carousel owl-theme">
                {venueHighlights.map((Highlights, index) => {
                  const truncated = truncateDescription(
                    Highlights.description,
                    100
                  );
                  const encodedPath = Highlights.image
                    .replace(/\(/g, "%28")
                    .replace(/\)/g, "%29")
                    .replace(/ /g, "%20");

                  const fullURL = `${encodedPath}`;
                  return (
                    <div
                      onClick={() => openModal(Highlights)}
                      key={index}
                      className="item bg-img"
                      style={{
                        backgroundImage: `url('${fullURL}')`,
                        height: "300px",
                      }}
                    >
                      <div className="content">
                        <a href={Highlights.url || "#"}>
                          <h5>{Highlights.venueHighlightsType}</h5>
                        </a>
                        <p style={{ height: "80px" }} title={truncated.full}>
                          {truncated.short}
                        </p>
                        <div className="arrow">
                          <a onClick={() => openModal(Highlights)}>
                            <span className="ti-arrow-right" />
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {isModalOpen && selectedHighlights && (
        <div id="ServiceModal" className="popup">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">
              {selectedHighlights.venueHighlightsType}
            </div>
            <div className="additional-text">
              <p>{selectedHighlights.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
